import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.new.spacing.large,
    marginTop: theme.new.spacing.medium,
  },
  tile: {
    border: `1px solid ${theme.new.color.line.hairline}`,
    borderRadius: theme.new.shape.borderRadius.medium,
    padding: theme.new.spacing.medium,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.xsmall,
  },
  labelRow: {
    alignItems: 'center',
    gap: theme.new.spacing.small,
  },
  count: {
    lineHeight: 1.3,
  },
  enrolled: {
    color: theme.new.color.brandPrimary,
  },
  errors: {
    color: theme.new.color.errorPrimary,
  },
  pending: {
    color: theme.new.color.warningPrimary,
  },
}));

export default useStyles;
